// Modules
import React, { Component } from 'react'
import hasPermission from './helpers/permissions.js';
import { BrowserRouter, Switch, Route, Redirect, withRouter } from 'react-router-dom';
import Echo from 'laravel-echo'
import { view } from '@risingstack/react-easy-state';
import axios from 'axios';
import { ProductContext } from './stores/session';
import request from './helpers/request.js';

// Local
import sessionState from './stores/session';
import session from './stores/session';
import endpoints from './helpers/endpoints';

// Pages

// Global Pages
import Reset from './pages/reset';
import LoginPage from './pages/login';
import Logout from './pages/logout';
import ActivatePage from './pages/activate';
import Account from './pages/account';
import DoReset from './pages/doReset';
import VersionHistory from './pages/version.js';

// User Pages
import PortalPage from './pages/portal';

// Admin
import Admin from './pages/admin/index';
import AdminCompanies from './pages/admin/companies';
import AdminCompany from './pages/admin/company';
import AdminUser from './pages/admin/user';
import Users from './pages/admin/users';
import ProductsPage from './pages/admin/products';
import ProductPage from './pages/admin/product';
import Audits from './pages/admin/audits';
import Usage from './pages/admin/usage.jsx';
import Translations from './pages/admin/translations';
import Tutorials from './pages/admin/tutorials';
import CompanySelect from './pages/admin/companySelect';
import DataFilters from './pages/admin/filters'
import DataFilter from './pages/admin/filter';

// Debug
import VersionPage from './pages/version'

// Background
import IdleTimer from './components/idleTimer/IdleTimer';

//VCA
import vacantCOTAlerts from './pages/modules/VacantCOTAlerts/vacantCOTAlerts';
import VacantCOTAlertsSearchWorkflow from './pages/modules/VacantCOTAlerts/VacantCOTAlertsSearchWorkflow';
import VacantCOTAlertsConfig from './pages/modules/VacantCOTAlerts/VacantCOTAlertsConfig';

//LTV
import LongTermVacantSummary from './pages/modules/LongTermVacant/LongTermVacantSummary';
import LongTermVacantSearch from './pages/modules/LongTermVacant/LongTermVacantSearch';
import LongTermVacantWorkflow from './pages/modules/LongTermVacant/LongTermVacantWorkflow';
import LongTermVacantDashboard from './pages/modules/LongTermVacant/LongTermVacantDashboard';

//
import BusinessAddressAlertSummary from './pages/modules/BusinessAddressAlert/BusinessAddressAlertSummary';
import BusinessAddressAlertSearch from './pages/modules/BusinessAddressAlert/BusinessAddressAlertSearch';
import BusinessAddressAlertWorkflow from './pages/modules/BusinessAddressAlert/BusinessAddressAlertWorkflow';

//
import MoslDqaSummary from './pages/modules/MoslDqa/MoslDqaSummary';
import MoslDqaSearch from './pages/modules/MoslDqa/MoslDqaSearch';

//
import InvalidPostcodeStreetSummary from './pages/modules/InvalidPostcodeStreet/InvalidPostcodeStreetSummary';
import InvalidPostcodeStreetSearch from './pages/modules/InvalidPostcodeStreet/InvalidPostcodeStreetSearch';
import InvalidPostcodeStreetWorkflow from './pages/modules/InvalidPostcodeStreet/InvalidPostcodeStreetWorkflow';

//
import AutomatedAddressCleanseSummary from './pages/modules/AutomatedAddressCleanse/AutomatedAddressCleanseSummary';
import AutomatedAddressCleanseSearch from './pages/modules/AutomatedAddressCleanse/AutomatedAddressCleanseSearch';
import AutomatedAddressCleanseWorkflow from './pages/modules/AutomatedAddressCleanse/AutomatedAddressCleanseWorkflow';

//
import MoslEligibilitySummary from './pages/modules/MoslEligibility/MoslEligibilitySummary.jsx';
import MoslEligibilitySearch from './pages/modules/MoslEligibility/MoslEligibilitySearch';
import MoslEligibilityWorkflow from './pages/modules/MoslEligibility/MoslEligibilityWorkflow';
import MoslEligibilityReport from './pages/modules/MoslEligibility/MoslEligibilityReport';

//
import Undeliverable from './pages/modules/Undeliverable/UndeliverableSummary.jsx';
import UndeliverableSearch from './pages/modules/Undeliverable/UndeliverableSearch';
import UndeliverableWorkflow from './pages/modules/Undeliverable/UndeliverableWorkflow';

//
import InvalidUprnVoa from './pages/modules/InvalidUprnVoa/InvalidUprnVoaSummary.jsx';
import InvalidUprnVoaSearch from './pages/modules/InvalidUprnVoa/InvalidUprnVoaSearch';
import InvalidUprnVoaWorkflow from './pages/modules/InvalidUprnVoa/InvalidUprnVoaWorkflow';

//

import PortfolioSummary from './pages/modules/PortfolioSummary/PortfolioSummary.jsx';
import PortfolioSearch from './pages/modules/PortfolioSummary/PortfolioSearch.jsx';

//
import AddressAssessment from './pages/modules/AddressAssessment/AddressAssessment';

//
import PriorityCleansingSummary from './pages/modules/PriorityCleansing/PriorityCleansingSummary.jsx';
import PriorityCleansingPremisesWorkflow from './pages/modules/PriorityCleansing/PriorityCleansingPremisesWorkflow.jsx';
import PriorityCleansingMetersWorkflow from './pages/modules/PriorityCleansing/PriorityCleansingMetersWorkflow.jsx';

//
import ManagedServiceSummary from './pages/modules/ManagedService/ManagedServiceSummary.jsx';
import ManagedServicePremisesWorkflow from './pages/modules/ManagedService/ManagedServicePremisesWorkflow.jsx';
import ManagedServiceMetersWorkflow from './pages/modules/ManagedService/ManagedServiceMetersWorkflow.jsx';

//
import NewSPIDsSummary from './pages/modules/NewSPIDs/NewSPIDsSummary.jsx';
import NewSPIDsWorkflow from './pages/modules/NewSPIDs/NewSPIDsWorkflow.jsx';

//
import UPRNChangesSummary from './pages/modules/UPRNChanges/UPRNChangesSummary.jsx';
import UPRNChangesPremisesWorkflow from './pages/modules/UPRNChanges/UPRNChangesPremisesWorkflow.jsx';

//
import MSNonAddressablesSummary from './pages/modules/MSNonAddressables/MSNonAddressablesSummary.jsx';
import MSNonAddressablesPremisesWorkflow from './pages/modules/MSNonAddressables/MSNonAddressablesPremisesWorkflow.jsx';
import MSNonAddressablesMetersWorkflow from './pages/modules/MSNonAddressables/MSNonAddressablesMetersWorkflow.jsx';

//
import VoaUpdatesSummary from './pages/modules/VoaUpdates/VoaUpdatesSummary.jsx';
import VoaUpdatesWorkflow from './pages/modules/VoaUpdates/VoaUpdatesWorkflow.jsx';

//
import InvalidUprnVoaCmos from './pages/modules/InvalidUprnVoaCmos/InvalidUprnVoaCmosSummary.jsx';
import InvalidUprnVoaCmosSearch from './pages/modules/InvalidUprnVoaCmos/InvalidUprnVoaCmosSearch';
import InvalidUprnVoaCmosWorkflow from './pages/modules/InvalidUprnVoaCmos/InvalidUprnVoaCmosWorkflow';

//
import MeterCoordinatesValidationSummary from './pages/modules/MeterCoordinatesValidation/MeterCoordinatesValidationSummary.jsx';
import MeterCoordinatesValidationSearch from './pages/modules/MeterCoordinatesValidation/MeterCoordinatesValidationSearch';
import MeterCoordinatesValidationWorkflow from './pages/modules/MeterCoordinatesValidation/MeterCoordinatesValidationWorkflow';

//
import LongUnreadMetersSummary from './pages/modules/LongUnreadMeters/LongUnreadMetersSummary.jsx';
import LongUnreadMetersSearch from './pages/modules/LongUnreadMeters/LongUnreadMetersSearch.jsx';
import LongUnreadMetersWorkflow from './pages/modules/LongUnreadMeters/LongUnreadMetersWorkflow.jsx';

//
import DataCleanseValidation from './pages/modules/DCV/DataCleanseValidation';
import DataCleanseValidationQA from './pages/modules/DCV/DataCleanseValidationQA';
import DataCleanseValidationAssurance from './pages/modules/DCV/DataCleanseValidationAssurance';

//
import SmartMeterRolloutSummary from './pages/modules/SmartMeterRollout/SmartMeterRolloutSummary';
import SmartMeterRolloutSearchWorkflow from './pages/modules/SmartMeterRollout/SmartMeterRolloutSearchWorkflow';
import SmartMeterRolloutConfig from './pages/modules/SmartMeterRollout/SmartMeterRolloutConfig';

//
import UPRNSearch from './pages/modules/UPRNSearch/UPRNSearch';

//
import ServiceComponents from './pages/modules/ServiceComponents/ServiceComponents';

import FSAMatch from './pages/modules/FSAMatch/FSAMatch';

//
import Groupings from './pages/admin/groupings';
import Grouping from './pages/admin/grouping';

import Alignments from './pages/admin/alignments';

import Maintenance from './pages/admin/maintenance.jsx';

import WorkflowReport from './components/workflow-report/WorkflowReport';

import PostcodeAssessment from './pages/modules/PostcodeAssessment/PostcodeAssessment';

//
import LoadingPage from './pages/loading';
import BrandingPage from './pages/admin/branding';
import AzureLoginPage from './pages/azureLogin';
import VacantCOTAlertsDashboard from './pages/modules/VacantCOTAlerts/VacantCOTAlertsDashboard';
import MaintenancePage from './pages/maintenance.js';
import BatchProcesses from './pages/admin/batchProcesses.jsx';



window.Pusher = require('pusher-js')

// window.Echo.channel('Platform.Products.contact_validation.refresh').notification((data) => console.log(data))

// window.Echo.pusher.config.auth.headers['Authorization'] = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9sb2NhbGhvc3Q6ODAwMFwvYXV0aFwvdG9rZW4iLCJpYXQiOjE2MTAzNzEyMzAsImV4cCI6MTYxMDM4MjAzMCwibmJmIjoxNjEwMzcxMjMwLCJqdGkiOiJPejg2allVUW9FbXNkdWYwIiwic3ViIjoxLCJwcnYiOiIyM2JkNWM4OTQ5ZjYwMGFkYjM5ZTcwMWM0MDA4NzJkYjdhNTk3NmY3In0.8Oq4LINTzfDMA_sn02NeVUkz-9BSXg1nuYl-wSCqphw'

export default view(class Router extends Component {
    state = {
        loaded: false,
        stage: 'Detecting Environment'
    }
    componentDidMount() {
        let a = axios.create({
            baseURL: endpoints.BASE
        });

        a.get(endpoints.DOMAIN + '?domain=' + window.location.hostname, {
            timeout: 30000
        }).then(e => {
            this.setState({ stage: 'Configuring App' })
            if (e.data.api_url) {
                sessionStorage.setItem('api-path', e.data.api_url);
                window.Echo = new Echo({
                    broadcaster: 'pusher',
                    key: 'IDENTEQ_PLATFORM_KEY',
                    wsHost: process.env.REACT_APP_WEBSOCKET_API_ENDPOINT ?? 'test.identeq-app.local',
                    wsPort: 6002,
                    wssPort: 6002,
                    forceTLS: false,
                    disableStats: true,
                    cluster: process.env.REACT_APP_WEBSOCKET_CLUSTER ?? 'mt1',
                })
            }

            if (e.data.login_video_url) {
                sessionStorage.setItem('login-video-path', e.data.login_video_url);
            }

            if (e.data.frontend_name) {
                sessionStorage.setItem('frontend-name', e.data.frontend_name);
            }

            if (e.data.branding) {
                document.title = `IDenteq ${e.data.branding.name}`
                console.log('Got branding')
                const vars = document.querySelector(':root')
                Object.keys(e.data.branding).filter(_ => _.indexOf('colour__') !== -1).forEach(colour => {
                    const c = colour.replace('colour', '').replaceAll('_', '').replaceAll(' ', '-').toLocaleLowerCase();
                    console.log(`--${c}`, e.data.branding[colour])
                    vars.style.setProperty(`--${c}`, e.data.branding[colour])
                })
                // --primary: var(--primary);
                // --secondary: #445468;
                // --background: #F7FCFF;
                // --gray: #A5A5A5;
                // --light-gray: #F7F7F7;
                // --white: #ffffff;
                // --black: #000000;
                // --logogreen: #009245;
                // --red: #f14014;
                // --yellow: #F19A14;
                // --blue: #118AB2;
                // --teal: #06D6A0;
                // --cobalt: #445469;

                if (e.data.branding.logo) {
                    sessionStorage.setItem('logo-url', e.data.branding.logo)
                }
                sessionState.company.can_azure_login = e.data.can_azure_login
            }

            console.log('Retrieved API Path: ' + sessionStorage.getItem('api-path'));

            setTimeout(() => {
                this.setState({
                    loaded: true
                })
            }, 1000);
        }).catch((error) => {
            console.log(error)
            if (error.response && error.response.data && error.response.data.maintenance_mode && window.location.pathname !== '/maintenance') {
                window.location.href = '/maintenance';
                return;
            }
            this.setState({
                stage: 'Failed to get environment, contact support'
            })
        })
    }

    render() {
        return (
            <div className="wrapper">
                <BrowserRouter>
                    <Switch>
                        {
                            !this.state.loaded ? <Route component={() => <LoadingPage stage={this.state.stage} />} /> : null
                        }
                        <Route path="/login/azure" component={AzureLoginPage} />
                        <Route path="/login" component={LoginPage} />
                        <Route path="/activate" component={ActivatePage} />
                        <Route path="/reset" component={Reset} />
                        <Route path="/auth/reset" component={DoReset} />
                        <Route path="/version" component={VersionPage} />
                        <Route path='/maintenance' component={MaintenancePage} />

                        {/* If not logged in redirect */}
                        {
                            !sessionState.token && window.location.pathname !== '/maintenance' ? <Redirect to={`/login?${window.location.pathname}`} /> : ''
                        }

                        <ProtectedRoute path="/version-history" component={VersionHistory} />

                        <ProtectedRoute path="/account" admin={null} exact={true} component={Account}/>

                        <ProtectedRoute path={["/portal/vacant-cot-alerts", "/portal/vacant-cot-alerts/plus"]} exact={true} component={vacantCOTAlerts} />
                        <ProtectedRoute path={["/portal/vacant-cot-alerts/dashboard", "/portal/vacant-cot-alerts/plus/dashboard"]} exact={true} component={VacantCOTAlertsDashboard} />
                        <ProtectedRoute path="/portal/vacant-cot-alerts/:searchOrWorkflow" exact={true} component={VacantCOTAlertsSearchWorkflow} configObject={VacantCOTAlertsConfig} />
                        <ProtectedRoute path="/portal/vacant-cot-alerts/plus/:searchOrWorkflow" exact={true} component={VacantCOTAlertsSearchWorkflow} configObject={{...VacantCOTAlertsConfig, isBdPlus: true, navigationPath: 'vacant-cot-alerts/plus'}} />

                        <ProtectedRoute path="/portal/long-term-vacant" exact={true} component={LongTermVacantSummary} />
                        <ProtectedRoute path="/portal/long-term-vacant/search" exact={true} component={LongTermVacantSearch} />
                        <ProtectedRoute path="/portal/long-term-vacant/workflow" exact={true} component={LongTermVacantWorkflow} />
                        <ProtectedRoute path="/portal/long-term-vacant/dashboard" exact={true} component={LongTermVacantDashboard} />

                        <ProtectedRoute path="/portal/invalid-postcode-street" exact={true} component={InvalidPostcodeStreetSummary} />
                        <ProtectedRoute path="/portal/invalid-postcode-street/search" exact={true} component={InvalidPostcodeStreetSearch} />
                        <ProtectedRoute path="/portal/invalid-postcode-street/workflow" exact={true} component={InvalidPostcodeStreetWorkflow} />

                        <ProtectedRoute path="/portal/automated-address-cleanse" exact={true} component={AutomatedAddressCleanseSummary} />
                        <ProtectedRoute path="/portal/automated-address-cleanse/search" exact={true} component={AutomatedAddressCleanseSearch} />
                        <ProtectedRoute path="/portal/automated-address-cleanse/workflow" exact={true} component={AutomatedAddressCleanseWorkflow} />

                        <ProtectedRoute path="/portal/mosl-eligibility" exact={true} component={MoslEligibilitySummary} />
                        <ProtectedRoute path="/portal/mosl-eligibility/search" exact={true} component={MoslEligibilitySearch} />
                        <ProtectedRoute path="/portal/mosl-eligibility/workflow" exact={true} component={MoslEligibilityWorkflow} />
                        <ProtectedRoute path="/portal/mosl-eligibility/report" exact={true} component={MoslEligibilityReport} />

                        <ProtectedRoute path="/portal/business-address-alert" exact={true} component={BusinessAddressAlertSummary} />
                        <ProtectedRoute path="/portal/business-address-alert/search" exact={true} component={BusinessAddressAlertSearch} />
                        <ProtectedRoute path="/portal/business-address-alert/workflow" exact={true} component={BusinessAddressAlertWorkflow} />

                        <ProtectedRoute path="/portal/mosl-dqa" exact={true} component={MoslDqaSummary} />
                        <ProtectedRoute path="/portal/mosl-dqa/search" exact={true} component={MoslDqaSearch} />

                        <ProtectedRoute path="/portal/undeliverable" exact={true} component={Undeliverable} />
                        <ProtectedRoute path="/portal/undeliverable/search" exact={true} component={UndeliverableSearch} />
                        <ProtectedRoute path="/portal/undeliverable/workflow" exact={true} component={UndeliverableWorkflow} />

                        <ProtectedRoute path="/portal/invalid-uprn-voa" exact={true} component={InvalidUprnVoa} />
                        <ProtectedRoute path="/portal/invalid-uprn-voa/search" exact={true} component={InvalidUprnVoaSearch} />
                        <ProtectedRoute path="/portal/invalid-uprn-voa/workflow" exact={true} component={InvalidUprnVoaWorkflow} />

                        <ProtectedRoute path="/portal/invalid-uprn-voa-cmos" exact={true} component={InvalidUprnVoaCmos} />
                        <ProtectedRoute path="/portal/invalid-uprn-voa-cmos/search" exact={true} component={InvalidUprnVoaCmosSearch} />
                        <ProtectedRoute path="/portal/invalid-uprn-voa-cmos/workflow" exact={true} component={InvalidUprnVoaCmosWorkflow} />

                        <ProtectedRoute path="/portal/meter-coordinates-validation" exact={true} component={MeterCoordinatesValidationSummary} />
                        <ProtectedRoute path="/portal/meter-coordinates-validation/search" exact={true} component={MeterCoordinatesValidationSearch} />
                        <ProtectedRoute path="/portal/meter-coordinates-validation/workflow" exact={true} component={MeterCoordinatesValidationWorkflow} />

                        <ProtectedRoute path="/portal/long-unread-meters" exact={true} component={LongUnreadMetersSummary} />
                        <ProtectedRoute path="/portal/long-unread-meters/search" exact={true} component={LongUnreadMetersSearch} />
                        <ProtectedRoute path="/portal/long-unread-meters/workflow" exact={true} component={LongUnreadMetersWorkflow} />

                        <ProtectedRoute path="/portal/portfolio-summary" exact={true} component={PortfolioSummary} />
                        <ProtectedRoute 
                            path={[
                                "/portal/portfolio-search",
                                "/portal/address-assessment-search",
                                "/portal/postcode-assessment-search"
                            ]}
                            exact={true} component={PortfolioSearch} 
                        />

                        <ProtectedRoute path="/portal/address-assessment" exact={true} component={AddressAssessment} />

                        <ProtectedRoute path="/portal/priority-cleansing" exact={true} component={PriorityCleansingSummary} />
                        <ProtectedRoute path="/portal/priority-cleansing/premises-workflow" exact={true} component={PriorityCleansingPremisesWorkflow} />
                        <ProtectedRoute path="/portal/priority-cleansing/meters-workflow" exact={true} component={PriorityCleansingMetersWorkflow} />

                        <ProtectedRoute path="/portal/managed-service" exact={true} component={ManagedServiceSummary} />
                        <ProtectedRoute path="/portal/managed-service/premises-workflow" exact={true} component={ManagedServicePremisesWorkflow} />
                        <ProtectedRoute path="/portal/managed-service/meters-workflow" exact={true} component={ManagedServiceMetersWorkflow} />

                        <ProtectedRoute path="/portal/new-spids" exact={true} component={NewSPIDsSummary} />
                        <ProtectedRoute path="/portal/new-spids/workflow" exact={true} component={NewSPIDsWorkflow} />
                        
                        <ProtectedRoute path="/portal/uprn-changes" exact={true} component={UPRNChangesSummary} />
                        <ProtectedRoute path="/portal/uprn-changes/premises-workflow" exact={true} component={UPRNChangesPremisesWorkflow} />
                        
                        <ProtectedRoute path="/portal/ms-non-addressables" exact={true} component={MSNonAddressablesSummary} />
                        <ProtectedRoute path="/portal/ms-non-addressables/premises-workflow" exact={true} component={MSNonAddressablesPremisesWorkflow} />
                        <ProtectedRoute path="/portal/ms-non-addressables/meters-workflow" exact={true} component={MSNonAddressablesMetersWorkflow} />

                        <ProtectedRoute path="/portal/voa-updates" exact={true} component={VoaUpdatesSummary} />
                        <ProtectedRoute path="/portal/voa-updates/workflow" exact={true} component={VoaUpdatesWorkflow} />

                        <ProtectedRoute path="/portal/new-spids" exact={true} component={NewSPIDsSummary} />
                        <ProtectedRoute path="/portal/new-spids/workflow" exact={true} component={NewSPIDsWorkflow} />

                        <ProtectedRoute path="/portal/uprn-search" exact={true} component={UPRNSearch} />

                        <ProtectedRoute path="/portal/service-components" exact={true} component={ServiceComponents} />

                        <ProtectedRoute path="/portal/fsa-match" exact={true} component={FSAMatch} />

                        <ProtectedRoute path="/portal/data-cleanse-validation" exact={true} component={DataCleanseValidation} />
                        <ProtectedRoute path="/portal/data-cleanse-validation/quality-assurance" exact={true} component={DataCleanseValidationQA} />
                        <ProtectedRoute path="/portal/data-cleanse-validation/assurance" exact={true} component={DataCleanseValidationAssurance} />

                        <ProtectedRoute path="/portal/smart-meter-rollout" exact={true} component={SmartMeterRolloutSummary} />
                        <ProtectedRoute path="/portal/smart-meter-rollout/:searchOrWorkflow" exact={true} component={SmartMeterRolloutSearchWorkflow} configObject={SmartMeterRolloutConfig} />

                        <ProtectedRoute path="/portal/workflow-reports" exact={true} component={WorkflowReport} />

                        <ProtectedRoute path="/portal/postcode-assessment" exact={true} component={PostcodeAssessment} />

                        <ProtectedRoute path="/portal" exact={true} component={sessionState.retailer ? MoslDqaSummary : PortalPage} />

                        <ProtectedRoute path="/admin/portal/company-select/:configuration" admin={true} exact={true} component={CompanySelect} />
                        <ProtectedRoute path="/admin/portal/companies/:company/translate" admin={true} exact={true} component={Translations} />
                        <ProtectedRoute path="/admin/portal/companies/:company/tutorials" admin={true} exact={true} component={Tutorials} />
                        <ProtectedRoute path="/admin/portal/companies/:company/batch-processes" admin={true} exact={true} component={BatchProcesses} />
                        <ProtectedRoute path="/admin/portal/companies/:company" admin={true} exact={true} component={AdminCompany} />
                        <ProtectedRoute path="/admin/portal/companies" admin={true} exact={true} component={AdminCompanies} />

                        <ProtectedRoute path="/admin/portal/branding/:id" admin={true} exact={true} component={BrandingPage} />
                        <ProtectedRoute path="/admin/portal/branding" admin={true} exact={true} component={BrandingPage} />

                        <ProtectedRoute path="/admin/portal/users/:user" admin={sessionState.company && hasPermission('ADMIN', 'CREATE-USER') ? false : true} exact={true} component={AdminUser} />
                        <ProtectedRoute path="/admin/portal/users" admin={true} exact={true} component={Users} />

                        <ProtectedRoute path="/admin/portal/products" admin={true} exact={true} component={ProductsPage} />
                        <ProtectedRoute path="/admin/portal/products/:product" admin={true} exact={true} component={ProductPage} />

                        <ProtectedRoute path="/admin/portal/filters/:id" admin={true} exact={true} component={DataFilter} />
                        <ProtectedRoute path="/admin/portal/filters" admin={true} exact={true} component={DataFilters} />

                        <ProtectedRoute path="/admin/portal/groupings/:id" admin={true} exact={true} component={Grouping} />
                        <ProtectedRoute path="/admin/portal/groupings" admin={true} exact={true} component={Groupings} />

                        <ProtectedRoute path="/admin/portal/audits" admin={true} exact={true} component={Audits} />

                        <ProtectedRoute path="/admin/portal/usage" admin={true} exact={true} component={Usage} routeTarget={"Usage"} />
                        <ProtectedRoute path="/admin/portal/Purchases" admin={true} exact={true} component={Usage} routeTarget={"Purchases"} />

                        <ProtectedRoute path="/admin/portal/align-environments" admin={true} exact={true} component={Alignments} />

                        <ProtectedRoute path="/admin/portal/maintenance" admin={true} exact={true} component={Maintenance} />

                        <ProtectedRoute path="/admin/portal" admin={true} exact={true} component={Admin} />

                        <ProtectedRoute path="/admin/portal/version-history" admin={true} exact={true} component={VersionPage} />

                        <Route path="/logout" component={Logout} />
                        { sessionState.company ?
                            <Redirect to="/portal" />
                        :
                            <Redirect to="/admin/portal" />
                        }
                    </Switch>
                </BrowserRouter>
            </div>
        )
    }
})

const ProtectedRoute = withRouter(view(class ProtectedRoute extends Component {
    constructor(props) {
        super(props);

        const { component, match, location, history, staticContext, computedMatch, configObject, ...data } = props;

        this.state = {
            authenticated: null,
            props: data,
            configObject: configObject ?? {}
        }
    }

    componentDidMount() {
        const alive = sessionState.isAlive();
        const admin = this.props.admin ?? false;

        if (alive === true) {
            if (admin === null) {
                this.updateAuthState(true);
            }

            this.updateAuthState((sessionState.company === null) === admin);
        } else if (alive === false) {
            this.updateAuthState(false);
        } else {
            alive.then(r => {
                if (admin === null) {
                    this.updateAuthState(true);
                }

                this.updateAuthState((sessionState.company === null) === admin);
            });
        }

        this.getProductData()
        if (this.state.configObject && this.state.configObject.productId) {
            this.getTranslations()
        }
    }

    componentDidUpdate(prevProps) {
        const prevPath = prevProps.location.pathname
        const nextPath = this.props.location.pathname

        const propsChanged = JSON.stringify(prevProps.configObject) !== JSON.stringify(this.props.configObject)
        const pathChanged = prevPath !== nextPath

        if (propsChanged && this.props.configObject) {
            this.setState(
                () => ({ configObject: this.props.configObject ?? {} }),
                () => {
                    if (this.state.configObject?.productId) this.getTranslations();
                    if (this.state.authenticated) this.getProductData();
                }
            );
        } else if (this.state.authenticated && pathChanged) {
            this.getProductData()
        }
    }

    getTranslations = () => {
        request(true).get(`/translate?key=${this.state.configObject.productId}`).then(r => {
            this.setState({configObject: {...this.state.configObject, translations: r.data}})
        }).catch(e => {
            console.error(e);
        })
    }

    getProductData = () => {
        const productUrl = () => {
            const containsPortal = window.location.pathname.indexOf('/portal/') !== -1
            const localPage = containsPortal ? window.location.pathname.substring('/portal/'.length) : window.location.pathname
            const product = localPage.substring(0, localPage.indexOf('/') !== -1 ? localPage.indexOf('/') : localPage.length)
            return containsPortal ? ( '/portal/' + product ) : product
        }
        request(true).get(`products?url=${productUrl()}`).then(r => {
            this.setState({configObject: {...this.state.configObject, product: r.data}})
        })
    }

    updateAuthState = (auth) => {
        this.setState({
            authenticated: auth
        }, () => {
            if (this.state.authenticated === false) {
                sessionState.reset();
                this.props.history.push('/login');
            }
        });
    }

    render() {
        return (
            <Route {...this.state.props} path={this.props.path} exact={this.props.exact} render={props => {
                const searchOrWorkflow = props.match?.params?.searchOrWorkflow;
                const isWorkflow = searchOrWorkflow === 'workflow';
                const contextValue = { ...this.props.configObject, translations: this.state.configObject?.translations ?? [], isWorkflow };
                return (
                    (
                        this.state.authenticated === true ? (
                            <ProductContext.Provider value={contextValue}>
                                <IdleTimer timeout={sessionState?.company?.idle_timeout || 20}/>
                                <this.props.component {...this.props} {...props} /> 
                            </ProductContext.Provider>
                        ) : <></>
                    )
                )
            }}/>
        );
    }
}))
